// extracted by mini-css-extract-plugin
module.exports = {"titleDescription":"TitleDescription_titleDescription__84Vvq","messageText":"TitleDescription_messageText__8gkiq"};